import { Col, Row } from "react-bootstrap";
import MaterialIcon from "../../../../ui-elements/material-icon/material-icon";

export interface IProfileField {
  label: string;
  value: string | undefined;
}

interface IProps {
  fields: IProfileField[];
  showEditIcon: boolean;
  handleEdit?: () => void;
}

const UserProfileDataEdit = ({ fields, showEditIcon, handleEdit }: IProps) => {
  return (
    <Row
      className={`bg-white rounded-4 mx-0 align-items-center justify-content-between p-3`}
    >
      <Col className="d-flex flex-column gap-3 w-100">
        {fields.map((field, index) => (
          <div key={index} className="d-flex flex-column">
            <span className="text-light font-size-12">{field.label}</span>
            <span className="text-dark font-size-16 font-weight-500 text-break">
              {field.value || "-"}
            </span>
          </div>
        ))}
      </Col>
      {showEditIcon && (
        <Col className="col-auto">
          <MaterialIcon
            icon="border_color"
            color="#7483CC"
            className="cursor-pointer"
            size={20}
            onClick={() => {
              if (handleEdit) handleEdit();
            }}
          />
        </Col>
      )}
    </Row>
  );
};

export default UserProfileDataEdit;
